module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="homeLogo" title="Retour au dashboard">\n</div>\n<div class="open_tasks">\n</div>\n<div class="menuLogo" title="Menu">\n</div>';

}
return __p
}